import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FacturaDtoList } from "./listmem";
import { FiltroComponent } from "./filtro";

import { FacturasToolbar } from "app/features/componentes/facturas";

interface Props2 {
    permisos: models.Rol;
}

interface State {
    filtro: models.FiltroFacturas;
    selected: number[]
}

export class FacturaListNoRx extends React.PureComponent<Props2, State> {
    constructor(props: Props2) {
        super(props);
        this.state = {
            filtro: {} as models.FiltroFacturas,
            selected: []
        };
    }

    modalManager = kea.createModalManager();

    filtro = (props: Props2, state: State): models.FiltroFacturas => ({
        ...state.filtro,
        EsCancelada: false
    });

    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Factura.Query, filtro));

    private onCancelar = async () => {
        const idFacturas = this.state.selected;
        if (await kea.yesno("¿Está seguro que quiere cancelar este conjunto de facturas?"))
            await resources.Factura.CancelarMultipleFacturas(idFacturas);
    }

    onFiltroChange = (x: models.FiltroFacturas) => this.setState({ filtro: x });
    onSelectedChange = (x: number[]) => this.setState({ selected: x });

    seleccionado = (props: Props2, x: State) => x.selected;

    render() {
        const items = this.items(this.props, this.state);


        const filtro = this.filtro(this.props, this.state);
        return (
            <div>
                <div className="btn-group">
                    <kea.Button disabled={this.state.selected.length <= 0} iconClass={fa("times-circle-o")} tooltip="Cancelar facturas" children="Cancelar facturas" style="danger" onClick={this.onCancelar} />
                </div>
                <FiltroComponent onChange={this.onFiltroChange} value={filtro} />
                <FacturaDtoList items={items} value={this.state.selected} onChange={this.onSelectedChange} />
                {this.modalManager.component}
            </div>
        );
    }
}

const FacturaListControlledRX = componentToRx(FacturaListNoRx);
class FacturaListControlled extends React.PureComponent<{}> {
    render() {
        return <FacturaListControlledRX permisos={resources.User.PermisoRx} />;
    }
}

export const MultiFacturaList = FacturaListControlled;


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacionmultiple/list.tsx